import { styled } from 'linaria/react';

export const CheckboxContainer = styled.div`
  @media (--only-mobile) {
    margin: var(--space-50) var(--space-175) 0 0;
  }
`;
